const routes = [
    {
        path: "/housing/building",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "housingbuilding_index"
        }
    }
]

export default routes;
